import { checkPhone, checkZip } from 'app/actions';
import { apiCall } from 'app/dealer/actions';
import { remapBranchForSubmit } from '../utils';
import { submitSepaBranchAssignment } from '../PaymentMethod/actions';

import * as ActionTypes from './constants';

export const getBranch = id => {
  return dispatch => {
    const url = `/networks/me/dealers/${id}`;

    dispatch({ type: ActionTypes.FETCH_BRANCH_REQUEST });

    return dispatch(apiCall(url, {}, true, true))
      .then(payload => {
        return dispatch({
          type: ActionTypes.FETCH_BRANCH_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.FETCH_BRANCH_FAILURE,
          error,
        });
      });
  };
};

/* istanbul ignore next */
export const getBranchAGB = id => {
  return (dispatch, getState) => {
    const { branch: branchState } = getState();
    const { branch } = branchState;
    const url = `/data/dealers/${branch.id}/terms-and-conditions`;

    dispatch({ type: ActionTypes.FETCH_BRANCH_AGB_REQUEST });

    return dispatch(apiCall(url, {}, true, true))
      .then(payload => {
        return dispatch({
          type: ActionTypes.FETCH_BRANCH_AGB_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.FETCH_BRANCH_AGB_FAILURE,
          error,
        });
      });
  };
};

export const getSepaMandates = () => {
  return dispatch => {
    const url = '/dealer-portal/sepa-mandates';

    dispatch({
      type: ActionTypes.GET_SEPA_MANDATES_REQUEST,
    });

    return dispatch(apiCall(url))
      .then(payload => {
        return dispatch({
          type: ActionTypes.GET_SEPA_MANDATES_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.GET_SEPA_MANDATES_FAILURE,
          error,
        });
      });
  };
};

export const setPaymentMethodStep = paymentMethodStep => {
  return {
    type: ActionTypes.SET_BRANCH_PAYMENT_METHOD_STEP,
    payload: paymentMethodStep,
  };
};

export const submitSepaMandate = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      branch: { sepaMandate, shouldSetDefaultSepa },
      branches: { branches },
    } = state;
    const url = '/dealer-portal/sepa-mandates';
    const request = {
      method: 'POST',
      body: JSON.stringify(sepaMandate),
    };

    dispatch({
      type: ActionTypes.SUBMIT_BRANCH_SEPA_MANDATE_REQUEST,
    });

    return dispatch(apiCall(url, request))
      .then(async payload => {
        if (shouldSetDefaultSepa) {
          const branchIds = branches.map(({ id }) => id);
          await dispatch(submitSepaBranchAssignment(payload.id, branchIds));
        }
        dispatch({
          type: ActionTypes.SUBMIT_BRANCH_SEPA_MANDATE_SUCCESS,
          payload,
        });
        dispatch({
          type: ActionTypes.RESET_BRANCH_SEPA_MANDATE,
        });

        return Promise.resolve();
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.SUBMIT_BRANCH_SEPA_MANDATE_FAILURE,
          error,
        });

        return Promise.resolve();
      });
  };
};

export const getTspList = () => {
  return dispatch => {
    const url = '/data/tsps?size=1000';

    dispatch({ type: ActionTypes.GET_TSPLIST_REQUEST });

    return dispatch(apiCall(url, {}, true, true))
      .then(payload => {
        return dispatch({
          type: ActionTypes.GET_TSPLIST_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.GET_TSPLIST_FAILURE,
          error,
        });
      });
  };
};

export const updateBranch = payload => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: ActionTypes.UPDATE_BRANCH,
        payload,
      });
      resolve();
    });
  };
};

/* istanbul ignore next */
export const updateBranchAGB = payload => {
  return (dispatch, getState) => {
    const { branch: branchState } = getState();
    const { branch } = branchState;

    const url = `/networks/me/dealers/${branch.id}/tnc/upload`;
    const method = payload.existing ? 'PATCH' : 'POST';
    const formData = new FormData();
    formData.append('file', payload.file);
    const request = {
      body: formData,
      isFileUpload: true,
      method,
    };

    dispatch({
      type: ActionTypes.SUBMIT_BRANCH_AGB_REQUEST,
    });

    return dispatch(apiCall(url, request, true, true))
      .then(payload => {
        return dispatch({
          type: ActionTypes.SUBMIT_BRANCH_AGB_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.SUBMIT_BRANCH_AGB_FAILURE,
          error,
        });

        return Promise.reject();
      });
  };
};

/* istanbul ignore next */
export const useHeycarAgb = () => {
  return (dispatch, getState) => {
    const { branch: branchState } = getState();
    const { branch } = branchState;

    const url = `/data/dealers/hack/${branch.id}`;
    const method = 'PUT';
    const request = {
      body: JSON.stringify({ termsAndConditionsLink: '' }),
      method,
    };

    dispatch({
      type: ActionTypes.USE_HEYCAR_AGB_REQUEST,
    });

    return dispatch(apiCall(url, request, true, true))
      .then(payload => {
        return dispatch({
          type: ActionTypes.USE_HEYCAR_AGB_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.USE_HEYCAR_AGB_FAILURE,
          error,
        });

        return Promise.reject();
      });
  };
};

export const updateSalesBrands = payload => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_SALES_BRANDS,
      payload,
    });
  };
};

export const updateSepaMandate = payload => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_BRANCH_SEPA_MANDATE,
      payload,
    });
  };
};

export const updateSepaTermsAccepted = payload => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_BRANCH_SEPA_TERMS_ACCEPTED,
      payload,
    });
  };
};

export const updateDefaultSepa = payload => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_ALL_BRANCHES_SEPAS,
      payload,
    });
  };
};

export const resetBranch = () => {
  return { type: ActionTypes.RESET_BRANCH };
};

export const checkBranchPhone = phone => {
  return dispatch => {
    dispatch({
      type: ActionTypes.CHECK_BRANCH_PHONE_REQUEST,
    });
    return dispatch(checkPhone(phone))
      .then(() => {
        return dispatch({
          type: ActionTypes.CHECK_BRANCH_PHONE_SUCCESS,
          payload: phone,
        });
      })
      .catch(() => {
        dispatch({
          type: ActionTypes.CHECK_BRANCH_PHONE_FAILURE,
          payload: phone,
        });
      });
  };
};

export const checkBranchZip = zip => {
  return dispatch => {
    dispatch({
      type: ActionTypes.CHECK_BRANCH_ZIP_REQUEST,
    });
    return dispatch(checkZip(zip))
      .then(() => {
        return dispatch({
          type: ActionTypes.CHECK_BRANCH_ZIP_SUCCESS,
          payload: zip,
        });
      })
      .catch(() => {
        return dispatch({
          type: ActionTypes.CHECK_BRANCH_ZIP_FAILURE,
          payload: zip,
        });
      });
  };
};

export const submitBranch = (existing = false) => {
  return (dispatch, getState) => {
    const { branch: branchState, network: networkState } = getState();
    const { branch } = branchState;
    const { network } = networkState;
    const remapped = remapBranchForSubmit(branch, network, false);

    const url = '/dealer-portal/dealers';
    const method = existing ? 'PATCH' : 'POST';
    const request = {
      body: JSON.stringify(remapped),
      method,
    };

    dispatch({
      type: ActionTypes.SUBMIT_BRANCH_REQUEST,
    });

    return dispatch(apiCall(url, request))
      .then(payload => {
        return dispatch({
          type: ActionTypes.SUBMIT_BRANCH_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.SUBMIT_BRANCH_FAILURE,
          error,
        });

        return Promise.reject();
      });
  };
};

export const updateOpeningTimesBlock = timeBlock => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_OPENING_TIMES_BLOCK,
      payload: timeBlock,
    });
  };
};

export const updateTspPermission = tspPermission => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_TSP_PERMISSION,
      payload: tspPermission,
    });
  };
};

export const validateFreespeePhoneAddress = () => {
  return (dispatch, getState) => {
    const { branch: branchState } = getState();
    const { branch } = branchState;

    dispatch({ type: ActionTypes.VALIDATE_FREESPEE_PHONE_ADDRESS_REQUEST });

    const url = `/leads/freespee/${branch.id}/validate`;

    const request = {
      body: JSON.stringify(branch),
      method: 'POST',
    };

    return dispatch(apiCall(url, request, true, true))
      .then(payload => {
        return dispatch({
          type: ActionTypes.VALIDATE_FREESPEE_PHONE_ADDRESS_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.VALIDATE_FREESPEE_PHONE_ADDRESS_FAILURE,
          error,
        });
      });
  };
};
